import React from "react";
import { Icon, Icomoon } from "../../brand/Icon/Icon";

import "./ShowMoreButton.scss";

export interface ShowMoreButton {
  onClick: () => void;
  isOpen: boolean;
}

/**
 * Show more/less button
 *
 * @status stable
 */
export const ShowMoreButton: React.FC<ShowMoreButton> = ({ onClick, isOpen }) =>
  <button
    type="button"
    className="show-more-button"
    onClick={() => onClick()}
  >
    <Icon icomoon={isOpen ? Icomoon.arrowUp3 : Icomoon.arrowDown3} />
    {isOpen ? "Show less" : "Show more"}
  </button>
